/**
 * Brazilian Portuguese strings for the `common` namespace — chrome shared across pages
 * (brand, nav, breadcrumb, footer, 404).
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 */
export const common = {
  brand: {
    name: 'RuneLedger',
    rune: 'RUNE',
    ledger: 'LEDGER',
  },
  nav: {
    label: 'Principal',
    home: 'Início',
    about: 'Sobre',
  },
  breadcrumb: {
    label: 'Trilha de navegação',
  },
  footer: {
    // Decorative rune row — not copy, but centralized so the chrome has zero literals.
    futhark: 'ᚠᚢᚦᚨᚱᚲ',
    legal:
      'RuneLedger é um projeto de fãs, sem afiliação com a Jagex Ltd. RuneScape é marca registrada da Jagex Ltd. Nesta fase, todos os dados exibidos são de demonstração.',
  },
  notFound: {
    rune: 'ᚹ',
    title: 'Página não encontrada',
    text: 'Este pergaminho não existe no códice.',
    back: 'Voltar ao início',
  },
}
